import AccountService from "../services/AccountService.js";

/**
 * Page /desinscription (/en/unsubscribe) : le lien « Se désinscrire en un clic »
 * des e-mails, rappels du Défi du jour ou nouveautés (`&list=news`). Chaque
 * liste se quitte seule : le message dit laquelle vient d'être coupée. La désinscription se fait au chargement, sans
 * connexion ni confirmation à cocher (RGPD art. 7.3 : aussi simple que de donner
 * son accord). C'est la page qui appelle l'API, pas le lien lui-même : les
 * antivirus et aperçus de liens qui visitent les URL des e-mails n'exécutent pas
 * de JavaScript, ils ne désabonnent donc personne à son insu.
 */
export default class UnsubscribePage {
    constructor() {
        this.page = document.querySelector(".page.unsubscribe-page");
        if (!this.page) return;
        this.t = (k) => window.geoNerdApp.languageManager.t(k);
        this.status = this.page.querySelector(".unsubscribe-status");
        this.actions = this.page.querySelector(".unsubscribe-actions");
        this.undoBtn = this.page.querySelector(".unsubscribe-undo");
        const params = new URLSearchParams(window.location.search);
        this.token = params.get("token");
        this.list = params.get("list") === "news" ? "news" : "reminders";
        // Messages propres à la liste quittée (`unsubscribe.doneNews`…).
        this.suffix = this.list === "news" ? "News" : "";

        this.undoBtn?.addEventListener("click", () => this.resubscribe());
        this.unsubscribe();
    }

    async unsubscribe() {
        if (!this.token) {
            this.show(this.t("unsubscribe.invalid"));
            return;
        }
        const res = await AccountService.unsubscribeEmail(this.token, this.list);
        if (res.ok) {
            this.show(this.t(`unsubscribe.done${this.suffix}`).replace("{email}", res.data?.email ?? ""), true);
        } else {
            this.show(this.t(res.status === 404 ? "unsubscribe.invalid" : "unsubscribe.error"));
        }
    }

    async resubscribe() {
        this.undoBtn.disabled = true;
        const res = await AccountService.resubscribeEmail(this.token, this.list);
        this.undoBtn.disabled = false;
        if (res.ok) {
            this.show(this.t(`unsubscribe.undone${this.suffix}`).replace("{email}", res.data?.email ?? ""), false);
        } else {
            this.show(this.t("unsubscribe.error"), true);
        }
    }

    /** @param {boolean} [canUndo] affiche « me réabonner » (après une désinscription réussie) */
    show(message, canUndo = false) {
        this.status.textContent = message;
        this.actions.hidden = false;
        this.undoBtn.hidden = !canUndo;
    }
}
